export const locationsData = [
  {
    name: "senderos",
    url: "senderos",
    slug: "senderos",
    type: "Terrenos",
    position: "top",
    shape: "poly",
    coords:
      //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
      "2404,2974 2534,2974 2533,3080 2404,3080",
    //centrarPin = xEsqSupDer-xEsqSupIzq=126 -> coordX=xEsqSupIzq+(126/2)=2467 -> coordY=ySuperior-80=2890
    pin: "M2467,2890c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-9,13-18,9-14,13-24,13-30C2497,2902,2483,2890,2467,2890Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S2475,2930,2467,2930Z",
  },
  {
    name: "alamos",
    url: "alamos",
    slug: "alamos",
    type: "Terrenos",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "3520,1950 3689,1950 3689,2036 3520,2036",
    //centrarPin = xEsqSupDer-xEsqSupIzq=169 -> coordX=xEsqSupIzq+(169/2)=3604 -> coordY=ySuperior-80=1870
    pin: "M3604,1870c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-9,13-18,9-14,13-24,13-30C3634,1882,3620,1870,3604,1870Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S3612,1910,3604,1910Z",
  },
  {
    name: "canadas",
    url: "canadas_casas",
    slug: "canadas-del-bosque",
    type: "casas",
    shape: "poly",
    position: "top",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "1059,510 1203,510 1203,628 1059,628",
    //centrarPin = xEsqSupDer-xEsqSupIzq=144 -> coordX=xEsqSupIzq+(144/2)=1131 -> coordY=ySuperior-80=430
    pin: "M1131,430c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-8,13-18,9-14,13-24,13-30C1161,442,1147,430,1131,430Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S1140,471,1131,471Z",
  },
  {
    name: "canadas",
    url: "canadas_terrenos",
    slug: "canadas-del-bosque",
    type: "Terrenos",
    shape: "poly",
    position: "left",
  },
  {
    name: "canadas",
    url: "canadas_deptos",
    slug: "canadas-del-bosque",
    type: "Departamentos",
    shape: "poly",
    position: "right",
  },
  {
    name: "vallenorte",
    type: "Terrenos",
    url: "vallenorte",
    slug: "valle-norte",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "562,382 746,382 746,491 562,491",
    //centrarPin = xEsqSupDer-xEsqSupIzq=184 -> coordX=xEsqSupIzq+(184/2)=654 -> coordY=ySuperior-80=302
    pin: "M654,302c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-9,13-18,9-14,13-24,13-30C684,314,671,302,654,302Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S663,342,654,342Z",
  },
  {
    name: "vallesur",
    url: "vallesur",
    slug: "valle-sur",
    type: "Terrenos",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "890,694 1072,694 1072,800 890,800",
    //centrarPin = xEsqSupDer-xEsqSupIzq=182 -> coordX=xEsqSupIzq+(182/2)=981 -> coordY=ySuperior-80=614
    pin: "M980,614c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0,0,6-9,13-18,9-14,13-24,13-30C1010,626,996,614,980,614Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S988,654,980,654Z",
  },
  {
    name: "paseodelparque",
    url: "paseodelparque",
    slug: "paseo-del-parque",
    type: "Terrenos",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "772,1832 999,1832 999,1910 772,1910",
    //derechaPin = coordX=xEsqSupDer=999-15 -> coordY=ySuperior-80=1752
    pin: "M984,1752c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-8,13-18,9-14,13-24,13-30C1014,1764,1000,1752,984,1752Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S992,1793,984,1793Z",
  },
  {
    name: "TPDP",
    url: "torrespaseodelparque",
    slug: "torres-paseo-del-parque",
    type: "Departamentos",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "753,1724 981,1724 981,1785 753,1785",
    //centrarPin = xEsqSupDer-xEsqSupIzq=228 -> coordX=xEsqSupIzq+(228/2)=867 -> coordY=ySuperior-80=1644
    pin: "M867,1644c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0,0,6-9,13-18,9-14,13-24,13-30C897,1656,883,1644,867,1644Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S876,1685,867,1685Z",
  },
  {
    name: "lomalta",
    url: "lomalta",
    slug: "loma-alta",
    type: "Terrenos",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "640,956 766,956 766,1077 640,1077",
    //centrarPin = xEsqSupDer-xEsqSupIzq=126 -> coordX=xEsqSupIzq+(126/2)=703 -> coordY=ySuperior-80=876
    pin: "M703,876c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-9,13-18,9-14,13-24,13-30C733,888,720,876,703,876Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S712,916,703,916Z",
  },
  {
    name: "ciudadsalud",
    url: "ciudadsalud",
    slug: "ciudad-salud",
    type: "Terrenos",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "515,759 749,759 749,893 515,893",
    //centrarPin = xEsqSupDer-xEsqSupIzq=347 -> coordX=xEsqSupIzq+(234/2)=632 -> coordY=ySuperior-80=679
    pin: "M632,679c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-9,13-18,9-14,13-24,13-30C662,691,649,679,632,679Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S641,719,632,719Z",
  },
  {
    name: "clubdegolf",
    url: "clubdegolf",
    slug: "club-de-golf",
    type: "Terrenos",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "1885,1742 2041,1742 2041,1902 1885,1902",
    //centrarPin = xEsqSupDer-xEsqSupIzq=156 -> coordX=xEsqSupIzq+(156/2)=1964 -> coordY=ySuperior-80=1662
    pin: "M1964,1662c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-9,13-18,9-14,13-24,13-30C1994,1674,1980,1662,1964,1662Z M1964,1703c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S1972,1703,1964,1703Z",
  },
  {
    name: "torreaireaplus",
    url: "torreaireaplus",
    slug: "torre-airea",
    type: "Departamentos",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "3370,2428 3485,2428 3485,2485 3370,2485",
    //centrarPin = xEsqSupDer-xEsqSupIzq=115 -> coordX=xEsqSupIzq+(115/2)=3427 -> coordY=ySuperior-80=2348
    pin: "M3427,2348c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-9,13-18,9-14,13-24,13-30C3457,2360,3444,2348,3427,2348Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S3436,2388,3427,2388Z",
  },
  {
    name: "bosques",
    url: "bosques_casas",
    slug: "bosques-tres-marias",
    type: "Casas",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "1486,988 1600,988 1600,1130 1486,1130",
    //centrarPin = xEsqSupDer-xEsqSupIzq=114 -> coordX=xEsqSupIzq+(114/2)=1543 -> coordY=ySuperior-80=908
    pin: "M1543,908c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-9,13-18,9-14,13-24,13-30C1573,920,1560,908,1543,908Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S1552,948,1543,948Z",
  },
  {
    name: "bosques",
    url: "bosques_terrenos",
    slug: "bosques-tres-marias",
    type: "Terrenos",
    position: "left",
    shape: "poly",
  },
  {
    name: "pradosur",
    url: "pradosur",
    slug: "prado-sur",
    type: "Terrenos",
    position: "top",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "1952,2890 2126,2890 2126,2969 1952,2969",
    //centrarPin = xEsqSupDer-xEsqSupIzq=174 -> coordX=xEsqSupIzq+(174/2)=2039 -> coordY=ySuperior-80=2810
    pin: "M2039,2810c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0,0,6-9,13-18,9-14,13-24,13-30C2069,2822,2056,2810,2039,2810Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S2048,2850,2039,2850Z",
  },
  {
    name: "zcpradosur",
    url: "zcpradosur",
    slug: "prado-sur",
    type: "Terrenos comerciales",
    position: "left",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "2173,2528 2350,2528 2350,2603 2173,2603",
    //izqPin = xEsqSupIzq+45 -> coordY=ySuperior-80=2448
    pin: "M2218,2448c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-0,6-9,13-18,9-14,13-24,13-30C2248,2460,2235,2448,2218,2448Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S2227,2488,2218,2488Z",
  },
  {
    name: "zcpeniasco",
    url: "zcpeniasco",
    slug: "peniasco",
    type: "Terrenos comerciales",
    position: "left",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "2549,2172 2684,2172 2684,2222 2549,2222",
    //izqPin = xEsqSupIzq -> coordY=ySuperior-80=2092
    pin: "M2549,2092c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0-1,6-9,13-18,9-14,13-24,13-30C2579,2104,2565,2092,2549,2092Zm0,40c-9,0-16-6-16-14s7-14,16-14,16,6,16,14S2558,2133,2549,2133Z",
  },
  /*
  {
    name: "torrevistahermosa",
    url: "torrevistahermosa/nombre_torre_etapa=TORREVISTAHERMOSA/cve_torre_etapa=92",
    type: "Departamentos",
    position: "left",
    shape: "poly",
    //EsqSupIzq EsqSupDer EsqInfDer EsqInfIzq
    coords: "3395,3695 3569,3695 3569,3829 3395,3829",
    //centrarPin = xEsqSupDer-xEsqSupIzq=174 -> coordX=xEsqSupIzq+(174/2)=3482 -> coordY=ySuperior-80=3615
    pin: "M3482,3615c-17,0-30,12-30,27,0,6,4,16,13,30,6,10,12,18,13,18l4,6,4-6c0,0,6,-9,13,-18,9,-14,13,-24,13,-30C3512,3627,3499,3615,3482,3615Zm0,40c-9,0-16,-6-16,-14s7,-14,16,-14,16,6,16,14S3491,3655,3482,3655Z",
  },
  */
];

/*
Editar un pin
No deben cambiarse (NO sumar px en X ni en Y):
Coordenadas relativas, que están en comandos en minúscula como:
c (curva cúbica relativa)
l (línea relativa)
m (movimiento relativo)
s, q, t, a en minúscula, etc.

Porque esas coordenadas son desplazamientos respecto al punto actual, no posiciones absolutas.

SÍ deben cambiarse (sumar px en X y/o px en Y):
Coordenadas absolutas, que aparecen en comandos en mayúscula, como:
M (movimiento absoluto)
L (línea absoluta)
C (curva cúbica absoluta)
S, Q, T, A en mayúscula, etc.

Porque esas coordenadas indican una posición fija en el espacio, y para desplazar todo el dibujo tienes que sumarles la cantidad correspondiente.
*/